export default __webpack_public_path__ + "static/media/655.3310d29f.png";